import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    showToast: {},
    notifications: [],
};

const toastSlice = createSlice({
    name: "toast",
    initialState,
    reducers: {
        showToast: (state, action) => {
            state.showToast = action.payload;
            
            // Add to notifications if persistent flag is set
            if (action.payload.persistent) {
                const newNotification = {
                    id: Date.now(),
                    timestamp: new Date().toISOString(),
                    severity: action.payload.severity,
                    summary: action.payload.summary,
                    read: false,
                };
                state.notifications.unshift(newNotification);
            }
        },
        hideToast: (state) => {
            state.showToast = {};
        },
        addNotification: (state, action) => {
            const newNotification = {
                id: Date.now(),
                timestamp: new Date().toISOString(),
                ...action.payload,
                read: false,
            };
            state.notifications.unshift(newNotification);
        },
        markNotificationAsRead: (state, action) => {
            const notificationIndex = state.notifications.findIndex(
                notification => notification.id === action.payload
            );
            if (notificationIndex !== -1) {
                state.notifications[notificationIndex].read = true;
            }
        },
        markAllNotificationsAsRead: (state) => {
            state.notifications = state.notifications.map(notification => ({
                ...notification,
                read: true,
            }));
        },
        clearNotification: (state, action) => {
            state.notifications = state.notifications.filter(
                notification => notification.id !== action.payload
            );
        },
        clearAllNotifications: (state) => {
            state.notifications = [];
        },
    },
});

export const { 
    showToast, 
    hideToast, 
    addNotification, 
    markNotificationAsRead,
    markAllNotificationsAsRead,
    clearNotification, 
    clearAllNotifications 
} = toastSlice.actions;

export default toastSlice.reducer;
